









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ActionToPlan extends Vue {
  @Prop({ required: true })
  readonly path: string
}
